import NoMember from 'src/features/auth/components/NoMember';

export default function NoMemberPage() {
  const handleSupport = () => {
    window.open('https://support.tekst.com');
  };
  return <NoMember redirectUrl="/plugins/outlook/login" className="w-full" handleSupport={handleSupport} />;
}
